var _Url_url, _Url_query;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import QueryStringCollection from './QueryStringCollection';
/** Defines a Url */
export default class Url {
    /**
     * Creates a new Url
     * @param baseUrl The Url to base this instance off of
     * @param queryStringObject Query string items as a plain object to add/update on the base Url. Set an item to undefined | null to remove it.
     */
    constructor(baseUrl, queryStringObject) {
        _Url_url.set(this, void 0);
        _Url_query.set(this, void 0);
        const [url, query] = baseUrl.toString().split('?', 2);
        __classPrivateFieldSet(this, _Url_url, url, "f");
        if (query === undefined) {
            __classPrivateFieldSet(this, _Url_query, new QueryStringCollection(), "f");
        }
        else {
            __classPrivateFieldSet(this, _Url_query, QueryStringCollection.createFromQueryString(query), "f");
        }
        if (queryStringObject !== undefined) {
            __classPrivateFieldSet(this, _Url_query, QueryStringCollection.merge(__classPrivateFieldGet(this, _Url_query, "f"), QueryStringCollection.createFromObject(queryStringObject)), "f");
        }
    }
    /** Gets the query section of this Url */
    get query() {
        return __classPrivateFieldGet(this, _Url_query, "f");
    }
    /** Sets the query section of this Url */
    set query(value) {
        __classPrivateFieldSet(this, _Url_query, value, "f");
    }
    toString() {
        return __classPrivateFieldGet(this, _Url_url, "f") + this.query.toString();
    }
    valueOf() {
        return this.toString();
    }
}
_Url_url = new WeakMap(), _Url_query = new WeakMap();
